import React from 'react';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import Menu from '@tencent/dui/lib/components/Menu';
import Divider from '@tencent/dui/lib/components/Divider';
import { PlatformUtil } from '../../../../utils/platform-utils.js';
import styles from './select-list.less.js';

/**
 * 下拉列表项目类型
 *
 * @public
 */
var ListType;
(function (ListType) {
    /**
     * 纯文字
     */
    ListType["Text"] = "normal";
    /**
     * 图标
     */
    ListType["Icon"] = "compact";
    /**
     * 图标文字混合
     */
    ListType["Mix"] = "with-icon";
})(ListType || (ListType = {}));
/**
 * 下拉列表组件，可用于工具栏
 *
 * @public
 */
class SelectList extends React.Component {
    constructor() {
        super(...arguments);
        this.handleSelect = (rawId) => {
            var _a;
            const id = this.getId(rawId);
            const selected = (_a = this.props.items) === null || _a === void 0 ? void 0 : _a.find(item => item.id === id);
            if (selected && this.props.onChange) {
                this.props.onChange(selected.id);
            }
        };
        this.handleMouseEnter = (rawId) => () => {
            var _a;
            const id = this.getId(rawId);
            const selected = (_a = this.props.items) === null || _a === void 0 ? void 0 : _a.find(item => item.id === id);
            if (selected && this.props.onMouseEnter) {
                this.props.onMouseEnter(id);
            }
        };
        this.handleMouseLeave = (rawId) => () => {
            var _a;
            const id = this.getId(rawId);
            const selected = (_a = this.props.items) === null || _a === void 0 ? void 0 : _a.find(item => item.id === id);
            if (selected && this.props.onMouseLeave) {
                this.props.onMouseLeave(id);
            }
        };
    }
    getId(rawId) {
        return rawId.replace('select-list-', '');
    }
    getDescription(item) {
        return typeof (item.description) === 'function' ? item.description() : item.description;
    }
    render() {
        var _a;
        const { style, selected, items = [], type = ListType.Text, className, } = this.props;
        const wrapperStyle = Object.assign({ overflow: 'auto', maxHeight: 'calc(100vh - 90px)' }, style);
        if (style) {
            wrapperStyle.maxHeight = `${window.innerHeight - 137}px`;
        }
        if (!items.length) {
            return React.createElement("div", null);
        }
        return React.createElement(Menu, { style: wrapperStyle, onClick: this.handleSelect, itemStyle: this.props.itemStyle, selectable: (_a = this.props.selectable) !== null && _a !== void 0 ? _a : true, type: type, className: className }, items.map((item, index) => {
            var _a, _b;
            if (item.id === 'divider') {
                return React.createElement(Divider, { key: `divider-${index}` });
            }
            const id = `select-list-${item.id}`;
            const key = `select-list-${index}`;
            const icon = type === ListType.Mix
                ? React.createElement("div", { className: styles['select-item-icon'] }, item.icon)
                : undefined;
            const content = type === ListType.Icon
                ? React.createElement("div", { className: styles['select-item-icon'] }, item.icon)
                : item.content;
            const element = React.createElement(Menu.Item, { id: id, key: key, selected: selected === item.id, icon: icon, style: item.style, disabled: item.disabled, description: this.getDescription(item), onMouseEnter: this.handleMouseEnter(id), onMouseLeave: this.handleMouseLeave(id), onMouseDown: (e) => { e.preventDefault(); } }, content);
            if (item.tooltips) {
                const shortcut = PlatformUtil.isMac() ? (_a = item.shortcut) === null || _a === void 0 ? void 0 : _a.mac : (_b = item.shortcut) === null || _b === void 0 ? void 0 : _b.win;
                let { tooltips } = item;
                if (shortcut) {
                    tooltips += `(${shortcut})`;
                }
                return (React.createElement(Tooltip, { key: index, title: tooltips, placement: "right", style: { display: 'block' } }, element));
            }
            return element;
        }));
    }
}

export { ListType, SelectList };
//# sourceMappingURL=select-list.js.map
